// IMPORT PICTURES
import blog from "./MockUpsJpg/BlogMockUp.jpg"
import blogMini from "./MockUpsJpg/Yp0x2m/blog.jpg"

import keydrum from "./MockUpsJpg/DrumMockUp.jpg"
import keydrumMini from "./MockUpsJpg/Yp0x2m/drum.jpg"

import github from "./MockUpsJpg/GithubMockUp.jpg"
import githubMini from "./MockUpsJpg/Yp0x2m/github.jpg"

import pokedex from "./MockUpsJpg/PokedexMockup.png"
import pokedexMini from "./MockUpsJpg/Yp0x2m/pokedex.jpg"

import portfolio from "./MockUpsJpg/Portfolio.jpg"
import portfolioMini from "./MockUpsJpg/Yp0x2m/portfolio.jpg"

import repeat from "./MockUpsJpg/RepeatMockUp.jpg"
import repeatMini from "./MockUpsJpg/Yp0x2m/repeat.jpg"

import secrets from "./MockUpsJpg/SecretsMockup.jpg"
import secretsMini from "./MockUpsJpg/Yp0x2m/secrets.jpg"

import tindog from "./MockUpsJpg/TinDog.jpg"
import tindogMini from "./MockUpsJpg/Yp0x2m/tindog.jpg"

import todo from "./MockUpsJpg/TodoMockUp.jpg"
import todoMini from "./MockUpsJpg/Yp0x2m/todo.jpg"




export const Projects = [
    {
        "name": "Pokedex",
        "desc": "A Pokedex app created using the PokeAPI.",
        "img": pokedex,
        "mini_img": pokedexMini,
        "site_url": "https://pokemon-pokemon.netlify.app/",
        "code_url": "https://github.com/simran7s/Pokedex-react",
        "skills": {
            "skill1": "React",
            "skill2": "HTML/CSS",
            "skill3": "JavaScript",
            "skill4": "Async",
            "skill5": "APIs",
            "skill6": ""
        },
        "search_filter": {
            "vanilla": false,
            "node": false,
            "react": true
        }
    },
    {
        "name": "Secrets App",
        "desc": "An app where you can anonymously post your secret for everyone to see.",
        "img": secrets,
        "mini_img": secretsMini,
        "site_url": "https://arcane-wildwood-95606.herokuapp.com/",
        "code_url": "https://github.com/simran7s/SecretsApp",
        "skills": {
            "skill1": "Node.js",
            "skill2": "OAuth2.0",
            "skill3": "Passport.js",
            "skill4": "Express.js",
            "skill5": "Mongoose",
            "skill6": "EJS"
        },
        "search_filter": {
            "vanilla": false,
            "node": true,
            "react": false
        }
    },
    {
        "name": "Github Finder",
        "desc": "A Github Profile Finder Applicaton that uses the Github API",
        "img": github,
        "mini_img": githubMini,
        "site_url": "https://g1thubf1nder.netlify.app/",
        "code_url": "https://github.com/simran7s/GithubFinder",
        "skills": {
            "skill1": "React",
            "skill2": "API",
            "skill3": "JavaScript",
            "skill4": "Env Variables",
            "skill5": "",
            "skill6": ""
        },
        "search_filter": {
            "vanilla": false,
            "node": false,
            "react": true
        }
    },
    {
        "name": "Blog Website",
        "desc": "Just a blog website with a backend",
        "img": blog,
        "mini_img": blogMini,
        "site_url": "https://frozen-journey-02026.herokuapp.com/",
        "code_url": "https://github.com/simran7s/BlogWebsite",
        "skills": {
            "skill1": "Node.js",
            "skill2": "Express.js",
            "skill3": "EJS",
            "skill4": "Mongoose",
            "skill5": "",
            "skill6": ""
        },
        "search_filter": {
            "vanilla": false,
            "node": true,
            "react": false
        }
    },
    {
        "name": "Repeat Game",
        "desc": "Copy the pattern game.",
        "img": repeat,
        "mini_img": repeatMini,
        "site_url": "https://simran7s.github.io/RepeatAfterMeGame/",
        "code_url": "https://github.com/simran7s/RepeatAfterMeGame/",
        "skills": {
            "skill1": "HTML",
            "skill2": "CSS",
            "skill3": "JavaScript",
            "skill4": "jQuery",
            "skill5": "",
            "skill6": ""
        },
        "search_filter": {
            "vanilla": true,
            "node": false,
            "react": false
        }
    },
    {
        "name": "TinDog",
        "desc": "If humans can find love online, why can't dogs?",
        "img": tindog,
        "mini_img": tindogMini,
        "site_url": "https://simran7s.github.io/Tinder-Dog-Version/",
        "code_url": "https://github.com/simran7s/Tinder-Dog-Version",
        "skills": {
            "skill1": "HTML",
            "skill2": "CSS",
            "skill3": "BootStrap",
            "skill4": "Figma",
            "skill5": "Wireframing",
            "skill6": ""
        },
        "search_filter": {
            "vanilla": true,
            "node": false,
            "react": false
        }
    },
    {
        "name": "TodoList",
        "desc": "Got something to do? Put it on the list. Finish that task? Then just delete it",
        "img": todo,
        "mini_img": todoMini,
        "site_url": "https://fathomless-crag-38423.herokuapp.com/",
        "code_url": "https://github.com/simran7s/todolist-v2",
        "skills": {
            "skill1": "Node.js",
            "skill2": "EJS",
            "skill3": "Express.js",
            "skill4": "JavaScript",
            "skill5": "Mongoose",
            "skill6": "Heroku"
        },
        "search_filter": {
            "vanilla": false,
            "node": true,
            "react": false
        }
    },
    {
        "name": "KeyDrum",
        "desc": "Have you ever wanted to play the drums ...with your keyboard?",
        "img": keydrum,
        "mini_img": keydrumMini,
        "site_url": "https://simran7s.github.io/KeyDrum/",
        "code_url": "https://github.com/simran7s/KeyDrum/",
        "skills": {
            "skill1": "HTML",
            "skill2": "CSS",
            "skill3": "JavaScript",
            "skill4": "",
            "skill5": "",
            "skill6": ""
        },
        "search_filter": {
            "vanilla": true,
            "node": false,
            "react": false
        }
    },
    {
        "name": "Portfolio",
        "desc": "My Personal Portfolio (the website you are on right now)",
        "img": portfolio,
        "mini_img": portfolioMini,
        "site_url": "https://google.com",
        "code_url": "https://github.com/simran7s/portfolio",
        "skills": {
            "skill1": "React",
            "skill2": "HTML/CSS",
            "skill3": "JavaScript",
            "skill4": "SVGs",
            "skill5": "Figma",
            "skill6": ""
        },
        "search_filter": {
            "vanilla": false,
            "node": false,
            "react": true
        }
    }
]